/**
 * /api/items client + types.
 *
 * 后端返回完整的 Feishu `im/v1/messages/:id` 原 payload 挂在 `content` 字段上；
 * 前端渲染时按 `msg_type` 分发，不关心后端是否已抽平文（搜索由后端做）。
 */

import { apiGet, apiSend } from "./client";

export type ItemKind = "own" | "shared";
export type Tab = "all" | "own" | "shared";
export type Sort = "list_time" | "original_time";

export interface Item {
  favorite_id: number;
  share_id: number | null;
  kind: ItemKind;

  msg_type: string;
  content: Record<string, unknown>;
  content_text: string;
  title: string | null;

  sender_open_id: string | null;
  sender_name: string | null;
  source_chat_id: string | null;
  message_id: string;

  shared_by_open_id: string | null;
  shared_by_name: string | null;
  via_group_id: number | null;

  pinned_at: string | null; // ISO 8601
  list_time: string;
  original_create_time: string | null;
}

export interface ListItemsResult {
  items: Item[];
  next_cursor: string | null;
}

export interface ListItemsParams {
  tab?: Tab;
  q?: string;
  sort?: Sort;
  cursor?: string | null;
  limit?: number;
  focus_share_id?: number | null;
}

export function listItems(p: ListItemsParams = {}): Promise<ListItemsResult> {
  const qs = new URLSearchParams();
  if (p.tab) qs.set("tab", p.tab);
  if (p.q) qs.set("q", p.q);
  if (p.sort) qs.set("sort", p.sort);
  if (p.cursor) qs.set("cursor", p.cursor);
  if (p.limit) qs.set("limit", String(p.limit));
  if (p.focus_share_id) qs.set("focus_share_id", String(p.focus_share_id));
  const s = qs.toString();
  return apiGet<ListItemsResult>(`/api/items${s ? `?${s}` : ""}`);
}

export function pinItem(
  kind: ItemKind,
  rowId: number,
  pinned: boolean,
): Promise<void> {
  return apiSend<void>(
    `/api/items/${kind}/${rowId}/pin`,
    pinned ? "POST" : "DELETE",
  );
}
